/**
 * Component to display and handle product sorting.
 * Sorting is being handled client-side via the updateProductsSortedBy method found in the context store, src/components/PeriodicTableContext.js
 */
import React, { useContext } from "react";
import Select from "react-select";
import { PeriodicTableContext } from "./PeriodicTableContext";
import { SORT_OPTIONS } from "../utils/constants";

const sortOptions = [
  SORT_OPTIONS.RELEVANCE,
  SORT_OPTIONS.FEATURED,
  SORT_OPTIONS.NEWEST,
  SORT_OPTIONS.ALPHA_ASC,
  SORT_OPTIONS.ALPHA_DESC,
];

const ResultsToolbar = () => {
  const {
    productsSorted,
    productsSortedBy,
    updateProductsSortedBy,
  } = useContext(PeriodicTableContext);

  const handleSortChange = (item) => {
    updateProductsSortedBy(item.value);
  };

  return (
    <>
      <hr className="category-divider"></hr>
      <div className="category-page-header">
        <span className="category-product-total-refine">
          <span className="category-product-total">
            {productsSorted.length} Products
          </span>
        </span>
        <div className="filter filter-sort">
          <h2 className="filter-title">Sort by:</h2>
          <form
            className="filter-sort-form"
            data-sort-by=""
            style={{ width: "10rem" }}
          >
            <Select
              className="form-select"
              id="customSearchSort"
              options={sortOptions}
              defaultValue={{
                value: productsSortedBy,
                label: sortOptions.find(
                  (option) => option.value === productsSortedBy
                ).label,
              }}
              onChange={handleSortChange}
              isSearchable={false}
              theme={(theme) => ({
                ...theme,
                borderRadius: 0,
                colors: {
                  ...theme.colors,
                  primary: "#2598ca",
                },
              })}
            />
          </form>
        </div>
      </div>
    </>
  );
};

export default ResultsToolbar;
